import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import { sublace } from '../common/sublace';

/** Ник из Discord → допустимый ник Flarum: латиница, цифры, _ и -, 3–30 символов. */
export function cleanUsername(name) {
  let value = String(name || '').normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9_-]+/gi, '_').replace(/_+/g, '_').replace(/^[_-]+|[_-]+$/g, '').slice(0, 30);
  if (value.length < 3) value = (value + '_player').slice(0, 30);
  return value;
}
function withSuffix(name, attempt) {
  const suffix = '_' + (attempt === 1 ? Math.floor(10 + Math.random() * 90) : Math.floor(1000 + Math.random() * 9000));
  return name.slice(0, 30 - suffix.length) + suffix;
}
function usernameTaken(error) {
  const errors = error && error.response && error.response.errors || [];
  return errors.some(e => e.source && /username/.test(e.source.pointer || '') && /taken|занят|уже/i.test(e.detail || ''));
}

/**
 * Регистрация через Discord в один клик: окно регистрации с данными из Discord
 * отправляется само. Если ник занят — пробуем ник с цифрами; если не вышло —
 * показываем обычное окно с ошибкой, чтобы игрок поправил ник сам.
 */
export default function addAutoRegister() {
  extend('flarum/forum/components/SignUpModal', 'oncreate', function () {
    if (sublace().oauthAutoRegister === false) return;
    if (!this.attrs.token || this.sublaceAutoTried) return;
    const email = this.email && this.email() || '';
    if (!email) return;
    this.sublaceAutoTried = true;
    const modal = this.element && (this.element.closest('.Modal') || this.element);
    modal && modal.classList.add('SublaceAutoRegister');
    const base = cleanUsername(this.username && this.username() || email.split('@')[0]);
    const token = this.attrs.token;
    const attempt = n => {
      const username = n === 0 ? base : withSuffix(base, n);
      this.username(username);
      this.loading = true;
      m.redraw();
      return app.request({
        url: app.forum.attribute('baseUrl') + '/register',
        method: 'POST',
        body: {
          username,
          email,
          token
        },
        errorHandler: () => {}
      }).then(() => window.location.reload(), error => {
        if (usernameTaken(error) && n < 3) return attempt(n + 1);

        // Не получилось само — обычное окно, ошибка показана как обычно.
        modal && modal.classList.remove('SublaceAutoRegister');
        this.loaded();
        this.onerror(error);
      });
    };
    attempt(0);
  });
}